import { InterviewHub } from "@/components/interview/InterviewHub";

export function SimulationsSection() {
  return <InterviewHub />;
}
